<template>
  <div class="sign-finish" :style="{height:isPhone?'calc(100vh - 120px)':'570px'}">
    <div class="wrap2" v-if="isPhone" style="position: relative;">
      <div style="display: flex;">
        <div class="actionsWrap">
          <div class="actions">
            <button class="danger" @click="handleClear2" >清除</button>
            <button class="warning" @click="handleUndo2" >撤销</button>
            <!-- <button class="primary" @click="handleFull" >竖屏</button> -->
            <button class="success" @click="handlePreview2" >保存</button>
          </div>
        </div>
        <canvas class="canvas" ref="canvas2" style="flex: 1;" />
      </div>
      <div style="font-size: 14px;padding: 10px;text-align: center;transform: translateY(-50%) rotate(90deg);width: 600px;height: 20px;position: absolute;top: 50%;">
        请学员签署<span style="font-size: 16px;font-weight: bold;color: red;">本人姓名</span>授权<span style="font-size: 16px;font-weight: bold;color: red;">支付</span> 扫码，支付服务费
      </div>
    </div>

    <div class="wrap1" v-else style="margin-top: 0px;height: 550px;">
      <div style="font-size: 26px;padding: 20px;text-align: center;">
        请学员签署<span style="font-size: 36px;font-weight: bold;color: red;">本人姓名</span>授权<span style="font-size: 36px;font-weight: bold;color: red;">支付</span> 扫码，支付服务费
      </div>
      <canvas class="canvas1" ref="canvas1" style="width: 800px;height: 400px;" />
      <div class="actions">
        <button class="danger" @click="handleClear1" >清除</button>
        <button class="warning" @click="handleUndo1" >撤销</button>
        <button class="success" @click="handlePreview1" >保存</button>
      </div>
    </div>
    <popup ref="popupShows"></popup>
  </div>
</template>

<script>
import SmoothSignature from "smooth-signature";
import popup from '../common/commonComponents/popup';

export default {
  name: "signer_jj",

  data() {
    return {
      showFull: false,
      isPhone:true,
      signature1:null
    };
  },
  components: {
    popup,
  },
  mounted() {
    var userAgent = navigator.userAgent;

    // 定义正则表达式进行匹配
    var isMobileRegex = /(Android|iPhone|SymbianOS|Windows Phone)/i;

    if (isMobileRegex.test(userAgent)) {
      console.log("这是移动设备"); // PC端输出"这是移动设备"
      this.initSignture2();
    } else {
      console.log("这是PC端"); // 移动端输出"这是PC端"
      this.isPhone = false
      this.$nextTick(()=>{
        this.initSignature1();
      })
    }
  },
  methods: {

    initSignature1() {
      const canvas = this.$refs["canvas1"];
      const options = {
        width: 800,
        height: 400,
        minWidth: 2,
        maxWidth: 6,
        openSmooth:true,
        // color: "#1890ff",
        // bgColor: '#f6f6f6',
      };
      this.signature1 = new SmoothSignature(canvas, options);

    },
    initSignture2() {
      const canvas = this.$refs["canvas2"];
      const options = {
        width: window.innerWidth - 80,
        height: window.innerHeight - 180,
        minWidth: 3,
        maxWidth: 10,
        openSmooth:true,
        // color: "#1890ff",
        // bgColor: '#f6f6f6',
      };
      this.signature2 = new SmoothSignature(canvas, options);
    },
    handleClear1() {
      this.signature1.clear();
    },
    handleClear2() {
      this.signature2.clear();
    },
    handleUndo1() {
      this.signature1.undo();
    },
    handleUndo2() {
      this.signature2.undo();
    },
    handleFull() {
      this.showFull = !this.showFull;
    },
    handlePreview1() {
      const isEmpty = this.signature1.isEmpty();
      if (isEmpty) {
        // 危险通知
        this.$refs.popupShows.popupShowing("请输入签名");
        return;
      }
      const canvas = this.signature1.getRotateCanvas();
      const pngUrl = canvas.toDataURL();
      // window.localStorage.setItem("signature", pngUrl);
      this.$emit('set-sign',pngUrl)
      // window.previewImage(pngUrl);
    },
    handlePreview2() {
      const isEmpty = this.signature2.isEmpty();
      if (isEmpty) {
        // 危险通知
        this.$refs.popupShows.popupShowing("请输入签名");
        return;
      }
      const canvas = this.signature2.getRotateCanvas(-90);
      const pngUrl = canvas.toDataURL();
      // window.localStorage.setItem("signature", pngUrl);
      this.$emit('set-sign',pngUrl)

    },
  },
};
</script>

<style lang="scss">
.sign-finish {
  // height: 100vh;
  // width: 100vw;
  button {
    height: 32px;
    padding: 0 8px;
    font-size: 12px;
    border-radius: 2px;
  }
  .danger {
    color: #fff;
    background: #ee0a24;
    border: 1px solid #ee0a24;
  }
  .warning {
    color: #fff;
    background: #ff976a;
    border: 1px solid #ff976a;
  }
  .primary {
    color: #fff;
    background: #1989fa;
    border: 1px solid #1989fa;
  }
  .success {
    color: #fff;
    background: #07c160;
    border: 1px solid #07c160;
  }
  canvas {
    border-radius: 10px;
    border: 2px dashed #ccc;

  }
  .wrap1 {
    height: 300px;
    width: 400px;
    margin: auto;
    margin-top: 100px;
    .actions {
      display: flex;
      justify-content: space-around;
    }
  }
  .wrap2 {
    padding: 15px;
    //display: flex;
    justify-content: center;
    .actionsWrap {
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .canvas {
      flex: 1;
    }
    .actions {
      margin-right: 10px;
      white-space: nowrap;
      transform: rotate(90deg);
      button{
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// signer_jj.vue?8d838918